import { uuid } from './uuid';
// 同一页面存在多 graph 时需要指定 graphId
export var getGraphId = function (graph, name) {
    if (graph.current) {
        return graph.current;
    }
    graph.current = "".concat(name, "-graph-").concat(uuid());
    return graph.current;
};
